import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";

export const MODULE_TYPE = "question";
export type TYPE = "question";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .back.staticInformation()
    .displayName("Question")
    .readOnly()
    .root.register();
